// Dockerコマンドのオプション情報
export const dockerCommandOptions = {
  run: {
    defaultBehavior: "指定したイメージからコンテナを作成して起動。フォアグラウンドで実行され、ポートやボリュームはマウントされない。",
    options: [
      { flag: "-d", origin: "detach（デタッチ）", role: "バックグラウンドで実行。デーモン化。" },
      { flag: "-p", origin: "publish（公開）", role: "ポートマッピング。ホスト:コンテナ形式。" },
      { flag: "-v", origin: "volume（ボリューム）", role: "ボリュームマウント。データ永続化に。" },
      { flag: "--name", origin: "name（名前）", role: "コンテナ名を指定。管理しやすくなる。" },
      { flag: "-e", origin: "environment（環境変数）", role: "環境変数を設定。設定値の注入に。" },
      { flag: "--rm", origin: "remove（削除）", role: "停止後に自動削除。一時コンテナに。" },
      { flag: "-it", origin: "interactive + tty", role: "対話モード。シェル操作可能に。" }
    ],
    combos: [
      { pattern: "docker run -d -p 80:80 --name web nginx", desc: "nginxをデーモンで起動＋ポート公開。Web公開の定番。" },
      { pattern: "docker run -it --rm ubuntu bash", desc: "Ubuntuの一時コンテナでbash起動。実験環境に。" },
      { pattern: "docker run -v $(pwd):/app -w /app node npm install", desc: "カレントディレクトリをマウントしてnpm実行。" }
    ]
  },

  build: {
    defaultBehavior: "カレントディレクトリのDockerfileを使ってイメージをビルド。タグ名を指定しないとタグなしイメージになる。",
    options: [
      { flag: "-t", origin: "tag（タグ）", role: "イメージ名とタグを指定。命名に必須。" },
      { flag: "-f", origin: "file（ファイル）", role: "Dockerfileのパスを指定。デフォルト以外を使用時。" },
      { flag: "--no-cache", origin: "no cache（キャッシュなし）", role: "キャッシュを使わずビルド。クリーンビルド。" },
      { flag: "--build-arg", origin: "build argument（ビルド引数）", role: "ビルド時の引数を指定。環境別ビルドに。" }
    ],
    combos: [
      { pattern: "docker build -t myapp:latest .", desc: "カレントディレクトリからイメージビルド。開発の基本。" },
      { pattern: "docker build --no-cache -t myapp:v2 .", desc: "キャッシュなしでクリーンビルド。問題解決に。" },
      { pattern: "docker build --build-arg ENV=prod -t myapp:prod .", desc: "引数付きビルド。環境別イメージ作成。" }
    ]
  },

  ps: {
    defaultBehavior: "現在実行中のコンテナのみ一覧表示。停止中のコンテナは表示されない。",
    options: [
      { flag: "-a", origin: "all（すべて）", role: "停止中コンテナも表示。全コンテナ確認。" },
      { flag: "-q", origin: "quiet（静か）", role: "コンテナIDのみ表示。スクリプト処理に。" },
      { flag: "--filter", origin: "filter（フィルター）", role: "条件でフィルタリング。絞り込み表示。" }
    ],
    combos: [
      { pattern: "docker ps", desc: "実行中コンテナ一覧表示。状態確認の基本。" },
      { pattern: "docker ps -a", desc: "全コンテナ表示。停止中も含めて確認。" },
      { pattern: "docker ps -q | xargs docker stop", desc: "全コンテナを一括停止。緊急停止に。" }
    ]
  },

  exec: {
    defaultBehavior: "実行中コンテナ内でコマンドを実行。デフォルトはフォアグラウンド実行。",
    options: [
      { flag: "-it", origin: "interactive + tty", role: "対話モードでコマンド実行。シェルアクセスに。" },
      { flag: "-d", origin: "detach（デタッチ）", role: "バックグラウンドで実行。" },
      { flag: "-u", origin: "user（ユーザー）", role: "実行ユーザーを指定。権限制御に。" }
    ],
    combos: [
      { pattern: "docker exec -it container_name bash", desc: "実行中コンテナにbashで入る。デバッグの定番。" },
      { pattern: "docker exec container_name ls /app", desc: "コンテナ内でコマンド実行。ファイル確認に。" }
    ]
  },

  logs: {
    defaultBehavior: "コンテナの標準出力/エラー出力の全ログを表示。過去のログから最新まで。",
    options: [
      { flag: "-f", origin: "follow（追従）", role: "ログをリアルタイム表示。tail -f相当。" },
      { flag: "--tail", origin: "tail（末尾）", role: "末尾N行のみ表示。最近のログ確認に。" },
      { flag: "--since", origin: "since（から）", role: "指定時刻以降のログを表示。" },
      { flag: "-t", origin: "timestamps（タイムスタンプ）", role: "タイムスタンプ付きで表示。時系列把握に。" }
    ],
    combos: [
      { pattern: "docker logs -f container_name", desc: "コンテナログをリアルタイム監視。デバッグの基本。" },
      { pattern: "docker logs --tail 100 container_name", desc: "直近100行のログ表示。最近のエラー確認。" },
      { pattern: "docker logs -t --since '1h' container_name", desc: "直近1時間のログをタイムスタンプ付きで表示。" }
    ]
  },

  images: {
    defaultBehavior: "ローカルに保存されているイメージを一覧表示。リポジトリ、タグ、サイズを含む。",
    options: [
      { flag: "-a", origin: "all（すべて）", role: "中間イメージも表示。全レイヤー確認。" },
      { flag: "-q", origin: "quiet（静か）", role: "イメージIDのみ表示。スクリプト処理に。" },
      { flag: "--filter", origin: "filter（フィルター）", role: "条件でフィルタリング。" }
    ],
    combos: [
      { pattern: "docker images", desc: "イメージ一覧表示。保存イメージ確認。" },
      { pattern: "docker images -a", desc: "中間イメージ含めて全表示。ディスク使用量調査。" }
    ]
  },

  rmi: {
    defaultBehavior: "指定イメージを削除。タグ名またはイメージIDを指定。コンテナで使用中なら失敗。",
    options: [
      { flag: "-f", origin: "force（強制）", role: "使用中でも強制削除。注意して使用。" }
    ],
    combos: [
      { pattern: "docker rmi image_name", desc: "イメージを削除。クリーンアップに。" },
      { pattern: "docker rmi $(docker images -q)", desc: "全イメージを一括削除。完全クリーンアップ。" }
    ]
  },

  volume: {
    defaultBehavior: "ボリューム管理のヘルプを表示。サブコマンド必須（create/ls/rm/prune）。",
    options: [
      { flag: "create", origin: "create（作成）", role: "ボリュームを作成。データ永続化の準備。" },
      { flag: "ls", origin: "list（一覧）", role: "ボリューム一覧を表示。" },
      { flag: "rm", origin: "remove（削除）", role: "ボリュームを削除。" },
      { flag: "prune", origin: "prune（刈り込む）", role: "未使用ボリュームを一括削除。" }
    ],
    combos: [
      { pattern: "docker volume create data_vol", desc: "データ用ボリューム作成。永続化準備。" },
      { pattern: "docker volume ls", desc: "ボリューム一覧表示。管理状況確認。" },
      { pattern: "docker volume prune", desc: "未使用ボリューム削除。ディスク容量回復。" }
    ]
  },

  network: {
    defaultBehavior: "ネットワーク管理のヘルプを表示。サブコマンド必須（create/ls/rm/connect）。",
    options: [
      { flag: "create", origin: "create（作成）", role: "ネットワークを作成。コンテナ間通信用。" },
      { flag: "ls", origin: "list（一覧）", role: "ネットワーク一覧を表示。" },
      { flag: "rm", origin: "remove（削除）", role: "ネットワークを削除。" },
      { flag: "connect", origin: "connect（接続）", role: "コンテナをネットワークに接続。" }
    ],
    combos: [
      { pattern: "docker network create app_network", desc: "アプリ用ネットワーク作成。マイクロサービス構成に。" },
      { pattern: "docker network ls", desc: "ネットワーク一覧表示。構成確認。" },
      { pattern: "docker network connect app_network container_name", desc: "コンテナをネットワークに接続。" }
    ]
  },

  "compose up": {
    defaultBehavior: "docker-compose.ymlで定義されたサービスをフォアグラウンドで起動。Ctrl+Cで停止。",
    options: [
      { flag: "-d", origin: "detach（デタッチ）", role: "バックグラウンドで起動。デーモン化。" },
      { flag: "--build", origin: "build（ビルド）", role: "起動前にイメージをビルド。更新反映に。" },
      { flag: "--scale", origin: "scale（スケール）", role: "サービスのコンテナ数を指定。負荷分散に。" }
    ],
    combos: [
      { pattern: "docker compose up -d", desc: "compose定義を起動。開発環境立ち上げの定番。" },
      { pattern: "docker compose up --build", desc: "ビルドしてから起動。コード変更反映に。" },
      { pattern: "docker compose up -d --scale web=3", desc: "webサービスを3コンテナで起動。負荷対策。" }
    ]
  },

  "compose down": {
    defaultBehavior: "composeで起動したコンテナとネットワークを停止＋削除。ボリュームは保持。",
    options: [
      { flag: "-v", origin: "volumes（ボリューム）", role: "ボリュームも削除。完全クリーンアップ。" },
      { flag: "--rmi", origin: "remove images（イメージ削除）", role: "イメージも削除。all/localを指定。" }
    ],
    combos: [
      { pattern: "docker compose down", desc: "compose環境を停止＋削除。終了処理の基本。" },
      { pattern: "docker compose down -v", desc: "ボリューム含めて完全削除。リセットに。" }
    ]
  },

  inspect: {
    defaultBehavior: "コンテナまたはイメージの詳細情報をJSON形式で表示。",
    options: [
      { flag: "--format", origin: "format（書式）", role: "出力フォーマットを指定。特定情報抽出に。" }
    ],
    combos: [
      { pattern: "docker inspect container_name", desc: "コンテナの詳細情報表示。設定確認に。" },
      { pattern: "docker inspect --format='{{.NetworkSettings.IPAddress}}' container_name", desc: "IPアドレスのみ抽出。ネットワーク調査に。" }
    ]
  },

  stats: {
    defaultBehavior: "全実行中コンテナのCPU、メモリ、ネットワークI/O使用状況をリアルタイム更新表示。",
    options: [
      { flag: "--no-stream", origin: "no stream（ストリームなし）", role: "1回だけ表示して終了。スナップショット取得。" },
      { flag: "-a", origin: "all（すべて）", role: "停止中コンテナも表示。" }
    ],
    combos: [
      { pattern: "docker stats", desc: "リソース使用状況をリアルタイム表示。パフォーマンス監視。" },
      { pattern: "docker stats --no-stream", desc: "現在のリソース状況を1回表示。スナップショット確認。" }
    ]
  },

  prune: {
    defaultBehavior: "未使用のコンテナ、ネットワーク、イメージ（ダングリング）、ビルドキャッシュを一括削除。",
    options: [
      { flag: "-a", origin: "all（すべて）", role: "未使用イメージを全削除。使用中以外全て。" },
      { flag: "--volumes", origin: "volumes（ボリューム）", role: "未使用ボリュームも削除。完全クリーンアップ。" }
    ],
    combos: [
      { pattern: "docker system prune", desc: "未使用リソース一括削除。定期メンテナンスに。" },
      { pattern: "docker system prune -a --volumes", desc: "未使用リソース完全削除。ディスク容量大幅回復。" },
      { pattern: "docker image prune", desc: "未使用イメージのみ削除。イメージクリーンアップ。" }
    ]
  },

  pull: {
    defaultBehavior: "指定イメージの最新版（latestタグ）をレジストリからダウンロード。",
    options: [
      { flag: "-a", origin: "all-tags（全タグ）", role: "全タグをプル。複数バージョン取得。" }
    ],
    combos: [
      { pattern: "docker pull nginx:latest", desc: "nginxの最新イメージ取得。ベースイメージ準備。" },
      { pattern: "docker pull ubuntu:22.04", desc: "特定バージョンを取得。環境固定に。" }
    ]
  },

  push: {
    defaultBehavior: "指定イメージをレジストリにアップロード。事前にタグ付けとログイン必要。",
    options: [
      { flag: "-a", origin: "all-tags（全タグ）", role: "全タグをプッシュ。" }
    ],
    combos: [
      { pattern: "docker push username/myapp:latest", desc: "イメージをレジストリにプッシュ。公開・共有に。" },
      { pattern: "docker tag myapp:latest registry.example.com/myapp:v1", desc: "タグ付けしてプライベートレジストリへ。" }
    ]
  },

  stop: {
    defaultBehavior: "実行中コンテナにSIGTERMを送信して停止。10秒後も動いていればSIGKILLで強制停止。",
    options: [
      { flag: "-t", origin: "time（時間）", role: "強制停止までの待機秒数。デフォルトは10秒。" }
    ],
    combos: [
      { pattern: "docker stop container_name", desc: "コンテナを停止。SIGTERM送信。" },
      { pattern: "docker stop $(docker ps -q)", desc: "全コンテナを一括停止。環境シャットダウン。" }
    ]
  },

  rm: {
    defaultBehavior: "停止中コンテナを削除。実行中の場合はエラー。",
    options: [
      { flag: "-f", origin: "force（強制）", role: "稼働中でも強制削除。" },
      { flag: "-v", origin: "volumes（ボリューム）", role: "関連ボリュームも削除。" }
    ],
    combos: [
      { pattern: "docker rm container_name", desc: "停止中コンテナを削除。" },
      { pattern: "docker rm -f container_name", desc: "稼働中コンテナを強制削除。" },
      { pattern: "docker rm $(docker ps -aq)", desc: "全コンテナを一括削除。完全クリーンアップ。" }
    ]
  },

  cp: {
    defaultBehavior: "コンテナ↔ホスト間でファイル/ディレクトリをコピー。双方向対応。",
    options: [
      { flag: "-a", origin: "archive（アーカイブ）", role: "アーカイブモード。権限保持してコピー。" }
    ],
    combos: [
      { pattern: "docker cp container_name:/app/file.txt ./", desc: "コンテナからファイル取り出し。ログ回収に。" },
      { pattern: "docker cp ./config.json container_name:/app/", desc: "コンテナにファイル転送。設定ファイル投入に。" }
    ]
  },

  login: {
    defaultBehavior: "Docker Hubまたは指定レジストリに対話形式でログイン。ユーザー名とパスワードを入力。",
    options: [
      { flag: "-u", origin: "username（ユーザー名）", role: "ユーザー名を指定。" },
      { flag: "-p", origin: "password（パスワード）", role: "パスワードを指定。スクリプト用。非推奨。" }
    ],
    combos: [
      { pattern: "docker login", desc: "Docker Hubにログイン。プライベートイメージアクセスに。" },
      { pattern: "docker login registry.example.com", desc: "プライベートレジストリにログイン。" }
    ]
  },

  tag: {
    defaultBehavior: "既存イメージに新しいタグを付与。同じイメージIDに複数の名前を割り当て。",
    options: [],
    combos: [
      { pattern: "docker tag myapp:latest myapp:v1.0", desc: "既存イメージに新タグ付与。バージョン管理に。" },
      { pattern: "docker tag myapp registry.example.com/myapp:latest", desc: "レジストリURLを含むタグ付け。プッシュ準備。" }
    ]
  },

  top: {
    defaultBehavior: "実行中コンテナ内のプロセス一覧をps形式で表示。",
    options: [],
    combos: [
      { pattern: "docker top container_name", desc: "コンテナ内プロセス一覧表示。動作確認に。" }
    ]
  },

  events: {
    defaultBehavior: "Dockerデーモンから発生するイベントをリアルタイムストリーム表示。",
    options: [
      { flag: "--since", origin: "since（から）", role: "指定時刻以降のイベントを表示。" },
      { flag: "--filter", origin: "filter（フィルター）", role: "イベントをフィルタリング。" }
    ],
    combos: [
      { pattern: "docker events", desc: "Dockerイベントをリアルタイム監視。システム動作監視に。" },
      { pattern: "docker events --filter 'type=container'", desc: "コンテナイベントのみ監視。" }
    ]
  },

  save: {
    defaultBehavior: "指定イメージを全レイヤー含めてtarアーカイブに保存。標準出力に出力。",
    options: [
      { flag: "-o", origin: "output（出力）", role: "出力ファイル名を指定。" }
    ],
    combos: [
      { pattern: "docker save -o myapp.tar myapp:latest", desc: "イメージをtarファイルに保存。オフライン移行に。" }
    ]
  },

  load: {
    defaultBehavior: "標準入力またはtarアーカイブからイメージを読み込んでロード。",
    options: [
      { flag: "-i", origin: "input（入力）", role: "入力ファイル名を指定。" }
    ],
    combos: [
      { pattern: "docker load -i myapp.tar", desc: "tarファイルからイメージ読込。オフライン環境へ展開。" }
    ]
  },

  context: {
    defaultBehavior: "現在アクティブなコンテキスト情報を表示。どのDocker環境に接続しているか確認。",
    options: [
      { flag: "create", origin: "create（作成）", role: "新しいコンテキスト作成。リモートDocker接続設定。" },
      { flag: "use", origin: "use（使用）", role: "使用するコンテキストを切替。" },
      { flag: "ls", origin: "list（一覧）", role: "コンテキスト一覧表示。" }
    ],
    combos: [
      { pattern: "docker context ls", desc: "コンテキスト一覧表示。接続先確認。" },
      { pattern: "docker context use remote", desc: "リモートDocker環境に切替。マルチ環境管理。" }
    ]
  }
};

export const getDockerOptions = (commandName) => {
  return dockerCommandOptions[commandName] || null;
};
